export const CONTENT_REVIEW_STATUSES = {
  overgenomen: {
    label: "Overgenomen",
    tone: "success",
    description: "Deze inhoud is herkenbaar overgenomen uit de huidige site.",
  },
  controleer: {
    label: "Controleer tekst",
    tone: "attention",
    description: "Deze tekst is samengevat, verplaatst of afhankelijk van actuele data.",
  },
  mist: {
    label: "Mist nog inhoud",
    tone: "missing",
    description: "Hier ontbreekt nog inhoud of actuele data voor de UAT-review.",
  },
  nieuw: {
    label: "Nieuw op UAT",
    tone: "new",
    description: "Dit onderdeel is nieuw in de UAT-versie.",
  },
  aangepast: {
    label: "Aangepast",
    tone: "changed",
    description: "Deze inhoud is bewust anders gepresenteerd dan op de huidige site.",
  },
};

export function getContentReviewStatus(status) {
  return CONTENT_REVIEW_STATUSES[status] || CONTENT_REVIEW_STATUSES.controleer;
}
